import React from 'react'
import { Link } from 'react-router-dom'
import LanguageSwitcherContainer from '../containers/LanguageSwitcherContainer'
import MainNav from './MainNav'
import Aux from '../hoc/Auxiliary'

class Header extends React.Component {

	render () {
		const { isMobile, isScrolled, onSideMenuOpen, isHome } = this.props
		const classes = isHome ? 'c-header c-header--home' : 'c-header'
		return <header className={`${classes} ${ isScrolled ? 'c-header--scrolled' : ''}`}>
			<div className='c-header__logo'>
				<Link to={'/'}>
					<img src='/img/logo.svg' alt='ZHK Jura Logo' />
				</Link>
			</div>
			<nav className='c-header__nav'>
				<Aux>
					<LanguageSwitcherContainer />
					{ !isMobile && <MainNav isHome={isHome} /> }
					{ isMobile &&
						<button className='c-btn--transparent' onClick={onSideMenuOpen}>
							<img src='/img/hamburger.svg' alt='menu icon' />
						</button>
					}
				</Aux>
			</nav>
		</header>
	}
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js